<!-- MessageBox.vue -->
<template>
  <div class="msg-box">
    <div class="icon-container">
      <img :src="imagePath" alt="사용자 아이콘" />
    </div>
    <div class="msg-container">
      <div class="msg">
        <img
          v-if="isLoading"
          class="loading-img"
          :src="loadingImgPath"
          alt="lawra_loading"
        />
        <div
          class="inner-html"
          v-html="parsedContent"
          :style="{ textAlign: isLoading ? 'center' : 'left' }"
        ></div>
      </div>
      <transition-group
        tag="div"
        name="caseref"
        class="caseref-box"
        v-if="isBot"
        appear
      >
        <case-ref-container
          v-for="(caseNum, index) in caseNums"
          :key="caseNum"
          :caseNum="caseNum"
          :style="{ 'transition-delay': 0.5 + index * 0.3 + 's' }"
          @summarize="$emit('summarize', $event)"
          @showref="$emit('showref', $event)"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import CaseRefContainer from '@/components/CaseRefContainer.vue';
import { marked } from 'marked';

export default {
  name: 'messageBox',
  components: { CaseRefContainer },
  props: {
    content: {
      type: String,
      required: true,
    },
    isBot: {
      type: Boolean,
      required: true,
    },
    caseNums: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      userIconPath: require('@/assets/icons/user_icon_default.png'),
      botIconPath: require('@/assets/icons/lawra_logo.png'),
      loadingImgPath: require('@/assets/icons/lawra_logo.svg'),
      caseNumsMock: ['95다39533', '67누890'],
    };
  },
  computed: {
    imagePath() {
      return this.isBot ? this.botIconPath : this.userIconPath;
    },
    parsedContent() {
      return marked(this.content);
    },
  },
};
</script>

<style>
.msg-box {
  display: flex;
  width: 97%;
  margin: 5% 0;
  align-items: flex-start;
}
.icon-container img {
  width: 30px;
  margin-top: 5px;
  padding: 2px;
  border: 1px solid rgb(104, 104, 104);
  border-radius: 50%;
  object-fit: cover;
}
.msg-container {
  max-width: 100%;
  margin-left: 10px;
  flex-grow: 1;
}
.loading-img {
  display: block;
  width: 100px;
  margin: 0 auto;
}
.msg {
  display: inline-block;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 8px;
  white-space: pre-wrap;
  word-break: break-all;
  overflow-wrap: break-word;
}
.msg li {
  margin-left: 20px;
}
.msg h2 {
  font-size: 1.3rem;
}
.msg h3 {
  font-size: 1.1rem;
}
.caseref-box {
  display: flex;
  flex-wrap: wrap;
  width: 97%;
}
.caseref-move,
.caseref-enter-active {
  transition: all 0.5s ease;
}
.caseref-enter-from {
  opacity: 0;
  transform: translateX(-10%);
}
.caseref-enter-to {
  opacity: 1;
}
</style>
